import { render, staticRenderFns } from "./VineyardAccountRequestReview.vue?vue&type=template&id=0d2124de&"
import script from "./VineyardAccountRequestReview.vue?vue&type=script&lang=js&"
export * from "./VineyardAccountRequestReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports